// Modal de vídeo da página de produto: os botões `.product-video-item` de
// main-product.liquid abrem o modal com o vídeo do `data-video-url`.
(() => {
  const modal = document.getElementById('product-video-modal');
  const player = document.getElementById('product-video-player');
  if (!modal || !player) return;
  const source = player.querySelector('source');

  const btnClose = modal.querySelector('.btn-close-modal');
  const btnPlay = modal.querySelector('.btn-toggle-play');
  const btnSound = modal.querySelector('.btn-toggle-sound');
  const iconPause = modal.querySelector('.icon-pause');
  const iconPlay = modal.querySelector('.icon-play');
  const iconSoundOn = modal.querySelector('.icon-sound-on');
  const iconSoundOff = modal.querySelector('.icon-sound-off');

  const updatePlayIcon = () => {
    iconPause.classList.toggle('icon-hidden', player.paused);
    iconPlay.classList.toggle('icon-hidden', !player.paused);
  };
  const updateSoundIcon = () => {
    iconSoundOn.classList.toggle('icon-hidden', player.muted);
    iconSoundOff.classList.toggle('icon-hidden', !player.muted);
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.product-video-item');
    if (!btn) return;
    e.preventDefault();
    const url = btn.dataset.videoUrl;
    if (!url) return;

    source.src = url;
    player.load();
    modal.style.display = 'flex';
    player.muted = false;
    updateSoundIcon();

    setTimeout(() => {
      modal.classList.add('active');
      player.play().then(updatePlayIcon).catch(() => {
        // O navegador bloqueou autoplay com som: muta e tenta de novo.
        player.muted = true;
        updateSoundIcon();
        player.play();
        updatePlayIcon();
      });
    }, 10);
  });

  const closeModal = () => {
    modal.classList.remove('active');
    player.pause();
    setTimeout(() => {
      modal.style.display = 'none';
      source.src = '';
    }, 300);
  };
  if (btnClose) btnClose.addEventListener('click', closeModal);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  if (btnPlay) {
    btnPlay.addEventListener('click', () => {
      if (player.paused) player.play();
      else player.pause();
      updatePlayIcon();
    });
  }

  if (btnSound) {
    btnSound.addEventListener('click', () => {
      player.muted = !player.muted;
      updateSoundIcon();
    });
  }
})();
